import React from 'react';
import { Link } from 'react-router-dom';

const RightSide = ({ recentPosts, comments, archieves, categories, tags  }) => (
  <div className="column">
      <div className="flex-card light-bordered">
          <div className="card-header">Güncel Yazılar</div>
          <div className="card-panel">
              <div className="recent-posts">
                  {
                    recentPosts.map(r => (
                      <>
                        <div className="recent-post">
                          <div className="post-title">
                            <a href={r.url}>{r.title}</a>
                          </div>
                          <div className="post-meta">
                            <span>{r.timeStamp}</span>
                            <img src={r.avatarUrl} alt="" />
                          </div>
                        </div>
                      </>
                    ))
                  }
              </div>
          </div>
      </div>
      {
        comments.length > 0
          ? (
            <div className="flex-card light-bordered">
                <div className="card-header">Latest comments</div>
                <div className="card-panel">
                    <div className="latest-comments">
                        {
                          comments.map(c => (
                            <div className="latest-comment">
                                <img src={c.avatarUrl} alt="" />
                                <div className="comment-info">
                                    <span className="name">{c.author} yorum yaptı. <span className="post-ref"><a href={c.url}>{c.title}</a></span></span>
                                </div>
                            </div>
                          ))
                        }
                    </div>
                </div>
            </div>
          )
          : ''
      }


      <div className="flex-card light-bordered">
          <div className="card-header">Arşiv</div>
          <div className="card-panel">
              <div className="archives">
                  {
                    archieves.map(a => (
                      <div className="archived-month">
                          <span><a href={a.url}>{a.title}</a></span>
                          <span className="b-badge badge-outlined rounded">{a.count}</span>
                      </div>
                    ))
                  }
              </div>
          </div>
      </div>

      <div className="flex-card light-bordered">
          <div className="card-header">Kategoriler</div>
          <div className="card-panel">
              <div className="post-categories">
                  {
                    categories.map(c => (
                      <div className="post-category">
                          <span><a href={c.url}>{c.title}</a></span>
                          <span className="b-badge badge-outlined rounded is-primary">{c.count}</span>
                      </div>
                    ))
                  }
              </div>
          </div>
      </div>

      <div className="flex-card light-bordered">
          <div className="card-header">Etiketler</div>
          <div className="card-panel padding-20">
              {
                tags.map(t => (
                  <span className="tag is-outlined is-primary"><a href={t.url}>{t.title}</a></span>
                ))
              }
          </div>
      </div>
  </div>
);

export default RightSide;
